export { LanguageData as default };

const LanguageData = {
  'menu' : {
    'items' : {
      'folders'  : 'Pastas',
      'compose'  : 'Nova mensagem',
      'contacts' : 'Contactos',
      'settings' : 'Definições',
      'develop'  : 'Develop',
      'logout'   : 'Sair',
      'loading'  : 'A carregar as pastas',
      'help'     : 'Ajuda',
    }
  },

  'global' : {
    'size_unknown' : 'Tamanho desconhecido',

    'actions' : {
      'select'       : 'Selecionar',
      'cancel'       : 'Cancelar',
      'close'        : 'Fechar',
      'more'         : 'Mais ações',
      'search'       : 'Pesquisar',
      'send'         : 'Enviar',
      'back'         : 'Voltar',
      'save'         : 'Guardar',
      'edit'         : 'Editar',
      'delete'       : 'Apagar',
      'confirm'      : 'Confirmar',
      'submit'       : 'Submeter',
      'next'         : 'Próximo',
      'previous'     : 'Anterior',
      'finish'       : 'Terminar',
      'start'        : 'Iniciar',
      'save_changes' : 'Guardar alterações',
      'ask_later'    : 'Perguntar mais tarde',
      'warning'      : 'Aviso',
      'copy_clipboard': 'Copiar para o clipboard',
      'copied_to_clipboard': 'Copiado para o clipboard',
    },

    'placeholders' : {
      'search': 'Pesquisar',
    },

    'content' : {
      'error' : {
        'title' : 'Não foi possível carregar este conteúdo.',
        'info'  : 'Por favor, verifique a sua ligação e volte a tentar.',
        'retry' : 'Tentar novamente',
      },

      'loading'        : 'A carregar, por favor, aguarde...',
      'page_not_found' : 'Página não encontrada.',
      'invalid'        : 'Este conteudo não existe.',
      'saving'         : 'A guardar alterações...'
    },

    'forms' : {
      'invalid': {
        'input' : 'Campo inválido',
        'email' : 'E-mail inválido',
      },
      'label': {
        'date_conjunction' : 'e',
        'between_dates'    : 'Entre as datas'
      }
    },

    'offline' : {
      'title'           : 'Sem ligação à internet',
      'text'            : 'Por favor, verifique a sua ligação e volte a tentar',
      'refresh'           : 'Atualizar',
    },

    'version': {
      'title': 'Atualização SAPO Mail',
      'subtitle': 'Clique para atualizar a página',
    }
  },

  'wizard' :  {
    'welcome' : {
      'header' : 'Obrigado por ter escolhido o SAPO Mail',
      'text_1' : 'Este assistente vai servir-lhe de guia através das opções para personalizar a aparência do SAPO Mail',
      'text_2' : 'Para começar, clique em ',
      'text_3' : 'Iniciar'
    },
    'theme_color' : {
      'header' : 'Selecione uma cor para o SAPO Mail',
    },

    'theme_mode' : {
      'header' : 'Selecione um modo de visualização',
    },

    'theme_orientation' : {
      'header' : 'Selecione uma orientação para o painel de mensagens',
    },

    'theme_font' : {
      'header' : 'Selecione um tamanho de letra',
    },

    'notifications' : {
      'header' : 'Activar notificações para este browser?',
    },

    'identity' : {
      'header' : 'Adicione um nome e uma assinatura às suas mensagens de e‑mail',
    },

    'closure' : {
      'header' : 'Já pode começar a usar o seu SAPO Mail',
      'text_1' : 'As opções de aparência e outras definições do SAPO Mail estão disponíveis no menu em',
      'link_1' : 'Definições',
      'text_2' : 'Clique em',
      'text_3' : 'Fechar',
      'text_4' : 'para sair do assistente',
    },

    'warning' : {
      'header'        : 'Assistente de configuração',
      'ask_later_text' : 'Irá fechar o assistente de configuração, quer guardar as alterações efetuadas?',
      'keep_changes'   : 'Guardar alterações',
      'revert_changes' : 'Cancelar alterações',
    }
  },

  'feedback' : {
    'title'         : 'Ajude-nos a melhorar o SAPO Mail',
    'opinion'       : 'Opinião',
    'label_rating'  : 'O que acha do novo SAPO Mail?',
    'label_message' : 'Encontrou um problema? Tem uma sugestão a fazer?',
    'info1'         : 'Este formulário destina-se apenas a recolher as suas opiniões.',
    'info2_part1'   : 'Se necessita de ajuda consulte',
    'info2_part2'   : 'esta página',
    'info2_part3'   : 'ou ligue 16200 (informação de custo da chamada em',
    'info2_part4'   : 'https://www.meo.pt/linhas-apoio',

    'notifications' : {
      'send_feedback_success' : 'O seu feedback foi enviado, Obrigado!!',
      'send_feedback_error'   : 'Não foi possivel enviar o seu feedback. Tente mais tarde',
    }
  },

  'editor' : {
    'fonts' : {
      'default' : 'Tipo de letra',
    },
    'sizes' : {
      'small'   : 'Pequeno',
      'medium'  : 'Normal',
      'large'   : 'Grande',
      'x-large' : 'Enorme',
      'xx-large': 'Gigante',
    },

    'images' : {
      'title'        : 'Imagem',
      'web_url'      : 'Endereço de imagem na Web',
      'preview_1'    : 'Se o URL estiver correto, verá uma pré-visualização da imagem aqui.',
      'preview_2'    : 'As imagens grandes poderão demorar alguns minutos a ser apresentadas.',
      'preview_error': 'Ocorreu um erro ao carregar a imagem.',
    },

    'inline_image' : {
      'small'   : 'Pequena',
      'default' : 'Original',
      'fit'     : 'Fit',
      'clear'   : 'Remover',
    },

    'image_loading_error': 'Erro ao carrega a imagem',
    'add_link'           : 'Adicionar link',
    'remove_link'        : 'Remover link',
    'link_title'         : 'Link',
    'emojis_title'       : 'Emojis',
    'text_link'          : 'Texto a mostrar',
    'text_placeholder'   : 'Texto',
    'protocol'           : 'Protocolo',
    'url'                : 'Endereço',
    'drag_image'         : 'Arraste a imagem para aqui',
    'drag_file'          : 'Arraste o ficheiro para aqui',
    'embed_image'        : 'Imagem na Mensagem',
    'attachments'        : 'Anexos',
    'pick_images'        : 'Selecionar imagens',

    'text_formatting'    : 'Formatação de Texto',
    'font_size'          : 'Tamanho de letra',
    'bold'               : 'Negrito',
    'italic'             : 'Itálico',
    'underline'          : 'Sublinhar',
    'color'              : 'Cor',
    'letter_color'       : 'Cor de letra',
    'background_color'   : 'Cor de fundo',
    'other_color'        : 'Outra cor',
    'strike'             : 'Riscado',
    'code'               : 'Código',
    'lists_quotes'       : 'Listas e citação',
    'ordered_list'       : 'Lista numerada',
    'unordered_list'     : 'Lista simples',
    'quote'              : 'Citação',
    'text_align'         : 'Alinhamento',
    'align_left'         : 'Alinhar à esquerda',
    'align_center'       : 'Alinhar ao centro',
    'align_right'        : 'Alinhar à direita',
    'justify'            : 'Justificar texto',
    'add_to_message'     : 'Adicionar à mensagem',
    'link'               : 'Adicionar Link',
    'photo'              : 'Fotografia',
    'emojis'             : 'Emojis',
    'remove_formatting'  : 'Remover formatação',
    'undo'               : 'Anular',
    'redo'               : 'Cancelar',
  },

  'notifications' : {
    'system_offline'                    : 'Serviço indísponivel.',
    'forbidden'                         : 'Pedido recusado.',
    'http_client_error'                 : 'Ocorreu um erro, por favor, tente mais tarde.',
    'internal_server_error'             : 'Ocorreu um erro, por favor, tente mais tarde.',
    'server_error'                      : 'Ocorreu um erro, por favor, tente mais tarde.',
    'compose_attachments_size_error'    : 'Excedeu o limite do tamanho total da mensagem permitido.',
    'compose_attachments_limit_error'   : 'Excedeu o limite de anexos para esta mensagem.',
    'compose_meo_cloud_size_error'      : 'Os ficheiros excedem o tamanho máximo permitido de 3GB.',
    'compose_meo_cloud_file_error'      : 'Não foi possivel enviar o ficheiro %s1 para a MEOCloud.',
    'compose_sapo_transfer_size_error'  : 'Os ficheiros excedem o tamanho máximo permitido de 3GB.',
    'compose_meo_cloud_quota_error'     : 'O tamanho dosficheiros excedem a quota limite da sua MEOCloud.',
    'compose_recipients_email_error'    : 'A mensagem contém destinatários com emails inválidos.',
    'compose_recipients_max_limit_error': 'A mensagem excede o número de destinatários permitidos (%s1).',
    'compose_recipients_min_limit_error': 'Tem de introduzir pelo menos um destinatário.',
    'compose_send_success'              : 'Mensagem enviada.',
    'compose_save_draft_success'        : 'A mensagem foi guardada na pasta Rascunhos.',
    'messages_move_top_warning'         : 'As mensagens não podem ser movidas para a pasta superior.',
    'messages_move_same_warning'        : 'As mensagens já estão na pasta %s1.',
    'messages_move_success'             : 'Mensagem movida para a pasta %s2.',
    'messages_move_success_multi'       : 'Foram movidas %s1 mensagens para a pasta %s2.',
    'messages_trash_success'             : 'Mensagem movida para a pasta Lixo.',
    'messages_trash_success_multi'       : 'Foram movidas %s1 mensagens para a pasta Lixo.',
    'messages_delete_success'           : 'Mensagem apagada.',
    'messages_delete_success_multi'     : 'Foram apagadas %s1 mensagens.',
    'messages_spam_success'             : 'A mensagem foi movida para a pasta Spam.',
    'messages_spam_success_multi'       : 'Foram movidas %s1 mensagens para a pasta Spam.',
    'messages_not_spam_success'         : 'Mensagem movida para a pasta Inbox com successo',
    'messages_not_spam_success_multi'   : 'Foram movidas %s1 mensagens para a pasta Caixa de Entrada.',
    'messages_spam_report_limit_error'  : 'Ação limitada a %s1 mensagens.',
    'message_move_not_selected'         : 'Selecione ao menos uma mensagem para mover',
    'folders_create_success'            : 'A pasta %s1 foi criada com successo.',
    'folders_edit_success'              : 'A pasta foi renomeada para %s1 com sucesso.',
    'folders_move_success'              : 'A pasta %s1 foi movida para %s2 com successo.',
    'folders_cant_move'                 : 'A pasta %s1 não pode ser movida para %s2.',
    'folders_delete_success'            : 'A pasta %s1 foi apagada com sucesso.',
    'folders_empty_success'             : 'A pasta %s1 foi esvaziada com sucesso.',
    'folders_empty_already'             : 'A pasta %s1 já está vazia.',
    'identities_delete_success'         : 'Identidade apagada com sucesso.',
    'identities_save_success'           : 'Identidade guardada com sucesso.',
    'identities_default_success'        : 'A sua identidade principal foi alterada.',
    'identities_delete_denied'          : 'Esta identidade não pode ser apagada.',
    'outofoffice_update_success'        : 'A sua mensagem de ausência foi alterada.',
    'settings_update_success'           : 'Definições alteradas.',
    'imap_disabled_success'             : 'IMAP e POP bloqueados.',
    'imap_enabled_success'              : 'IMAP e POP desbloqueados.',
    'filter_deleted_success'            : 'Filtro %s1 removido.',
    'filter_save_success'               : 'Filtro %s1 guardado.',
    'filter_enabled_success'            : 'Filtro %s1 Activado',
    'filter_disabled_success'           : 'Filtro %s1 Desativado',
    'newsletter_subscrition_success'    : 'Obrigado! A subscrição %s1 foi efetuada com sucesso.',
    'newsletter_unsubscription_success' : 'A subscrição %s1 foi removida com sucesso.',
    'popnotification_toggle_success'    : 'Definições guardadas com sucesso',
    'housekeeper_job_added'             : 'Limpeza de email adicionada.',
    'housekeeper_session_error'         : 'Sessão expirada.',
    'housekeeper_destination_error'     : 'Pasta de destino inválida.',
    'houserkeeper_expired_error'        : 'A pesquisa expirou.',
    'housekeeper_messages_error'        : 'Mensagens inválidas.',
    'forwards_save_success'             : 'Alterações guardadas com sucesso.',
    'forwards_delete_success'           : 'Alterações guardadas com sucesso.',
    'whitelist_delete_success'          : 'Endereço removido da lista de endereços permitidos.',
    'whitelist_add_success'             : 'Endereço(s) adicionado(s) à lista de endereços permitidos.',
    'blacklist_delete_success'          : 'Endereço removido da lista de endereços bloqueados.',
    'blacklist_add_success'             : 'Endereço(s) adicionado(s) à lista de endereços bloqueados.',
    'smokescreen_generate_success'      : 'Endereço incógnito gerado com sucesso.',
    'smokescreen_disable_success'       : 'Endereço incógnito desativado com sucesso.',
    'smokescreen_enable_success'        : 'Endereço incógnito ativado com sucesso.',

    'contacts_person_update_success'     : 'O contacto %s1 foi alterado.',
    'contacts_person_add_success'        : 'O contacto %s1 foi criado.',
    'contacts_group_update_success'      : 'O grupo %s1 foi alterado..',
    'contacts_group_add_success'         : 'O grupo %s1 foi criado.',
    'contacts_contact_delete_success'    : 'O contacto foi apagado.',
    'contacts_contacts_delete_success'   : 'Os contactos foram apagados.',
    'contacts_add_to_group_success'      : 'O(s) contacto(s) from adicionados ao grupo %s1',
    'contacts_remove_from_group_success' : 'O(s) contacto(s) foram removidos do grupo %s1',
    'contacts_contacts_delete_error'     : 'Ocorreu um erro a apagar o contacto.',
    'contacts_group_add_error'           : 'Ocorreu um erro a adicionar o grupo %s1.',
    'contacts_group_update_error'        : 'Ocorreu um erro a alterar o grupo %s1.',
    'contacts_person_update_error'       : 'Ocorreu um erro a alterar o contacto %s1.',
    'contacts_person_add_error'          : 'Ocorreu um erro a adicionar o contacto %s1.',
    'contacts_add_to_group_error'        : 'Ocorreu um erro a adicionar os contactos ao grupo',
    'contacts_remove_from_group_error'   : 'Ocorreu um erro a remover os contactos do grupo',
    'contacts_limit_error'               : 'Atingiu o número limite de contactos',
    'success_person_list_add'            : 'Lista de contactos importado com sucesso',

    'meo_cloud_upload_error'             : 'Serviço indísponivel, por favor, tente mais tarde.',
    'meo_cloud_upload_to_cloud_success'  : 'O anexo foi enviado para o MEO Cloud com sucesso.',
    'meo_cloud_upload_to_cloud_error'    : 'Não foi possivel enviar o anexo para o MEO Cloud.',
    'sapo_transfer_upload_error'         : 'Serviço indísponivel, por favor, tente mais tarde.',
    'sapo_transfer_sign_error'           : 'Serviço indísponivel, por favor, tente mais tarde.',
    'meo_cloud_maintenence'              : 'Serviço indísponivel, por favor, tente mais tarde.',

    'auth_success'                : 'Definições guardadas com sucesso',
    'kids_auth_alias_empty'       : 'Alias do educador não pode ficar vazio',
    'kids_auth_pass_empty'        : 'A password do educador não pode ficar vazio',
    'kids_auth_alias_error'       : 'Encarregado de educação inválido.',
    'kids_auth_submission_error'  : 'Requisição está bloqueada por throttling',
    'kids_auth_submission_invalid': 'Requisição inválida',
    'kids_auth_submission_token'  :'Requisição falhou na validação do token',
    'kids_auth_sso_error'         : 'Autenticação inválida',
    'kids_prefs_server_error'     : 'Erro ao guardar definições',
    'kids_prefs_whitelist_dup'    : 'O email %s1 já existe na lista autorizada.',
    'kids_prefs_update_success'   : 'Definições guardadas com sucesso',
    'kids_prefs_add_whitelist'    : 'Contacto %s1 adicionado na whitelist com sucesso',
    'kids_prefs_remove_whitelist' : 'Contacto %s1 removido da whitelist com sucesso',

    'wizard_settings_ask_later_success' : 'Voltaremos a perguntar mais tarde. Obrigado!',
    'wizard_settings_finished_success'  : 'As suas definições foram alteradas.',

    'editor_image_size_limit'    : 'A(s) imagem(s) excedem o tamanho máximo permitido de %s1Kb.',
    'editor_html_size_limit'     : 'O tamanho da mensagem excede o limite máximo permitido de %s1Kb.',
    'page_not_found': 'A página que tentou aceder não existe.'
  },

  'user_dashboard' : {
    'my_account'        : 'A minha conta',
    'my_profile'        : 'O meu perfil',
    'password_reset'    : 'Alterar password',
    'manage_recover'    : 'Dados de recuperação',
    'usage'             : 'Espaço utilizado',
    'manage_premium'    : 'Gerir Plano Premium',
    'account_premium'   : 'Plano Premium',
    'account_free'      : 'Plano Base',
    'upgrade_premium'   : 'Aderir ao Premium',
    'recover_warning_1' : 'Ainda não preencheu os seus',
    'recover_warning_2' : 'Dados de recuperação',
    'quota_warning'     : 'Está a usar %s1% do espaço disponível.',
    'usage_1' : 'A utilizar',
    'usage_2' : 'de',
    'links': {
      'manage_recover': 'https://id.sapo.pt/a/manage_recovery'
    },

    'overquota_virtual_1'  : 'Está a usar mais espaço do que a sua conta permite. Se a conta permanecer neste estado, ',
    'overquota_virtual_2'  : 'deixará de ser possível receber ou enviar mensagens.',
    'overquota_virtual_4'  : 'Usa a opção',
    'overquota_virtual_5'  : 'Limpeza de E-mail',
    'overquota_virtual_6'  : 'para apagar mensagens e libertar espaço na sua conta.',

    'overquota_1'  : 'Está a usar mais espaço do que a sua conta permite.',
    'overquota_2'  : 'Não é possível receber ou enviar mensagens',
    'overquota_3'  : 'quando a conta está a usar espaço acima do limite.',
    'overquota_4'  : 'Usa a opção',
    'overquota_5'  : 'Limpeza de E-mail',
    'overquota_6'  : 'para apagar mensagens e libertar espaço na sua conta.',
    'more_space_1' : 'Precisa de mais espaço? Adira ao SAPO Mail Premium',
  },

  'messages' : {
    'actions' : {
      'close'           : 'Fechar',
      'more'            : 'Mais ações',
      'source_code'     : 'Ver código fonte',
      'print'           : 'Imprimir',
      'add_filter'      : 'Criar filtro',
      'remove_filter'   : 'Remover filtros',
      'filter'          : 'Filtrar e ordenar',
      'open_popup'      : 'Abrir mensagem numa nova janela',
      'open_inline'     : 'Continuar a escrever na janela principal',
      'forward'         : 'Encaminhar',
      'select_all'      : 'Selecionar todas',
      'select_reset'    : 'Desmarcar todas',
      'change_flagged'  : 'Alterar sinalização',
      'mark_flagged'    : 'Sinalizar',
      'mark_unflagged'  : 'Remover sinalização',
      'mark_unread'     : 'Por ler',
      'mark_read'       : 'Lida',
      'move_message'    : 'Mover',
      'move_trash'      : 'Apagar',
      'mark_spam'       : 'Spam',
      'mark_not_spam'   : 'Não Spam',
      'download'        : 'Guardar',
      'refresh'         : 'Atualizar mensagens',
      'compose'         : 'Nova mensagem',
      'save_draft'      : 'Guardar nos rascunhos',
      'expand'          : 'Expandir',
      'search'          : 'Pesquisar',
      'popup'           : 'Abrir numa nova janela',
      'whitelist_email' : 'Nunca bloquear endereço',
      'blacklist_email' : 'Bloquear endereço',
    },

    'ads' : {
      'tooltip_remove' : 'Remover publicidade',
    },

    'delete' : {
      'warning_title_singular' : 'Apagar %s1 mensagem',
      'warning_title_plural'   : 'Apagar %s1 mensagens',
      'warning_text_1'         : 'Tem a certeza que deseja apagar %s1 ',
      'warning_text_2'         : 'As mensagens selecionadas serão apagadas definitivamente.',
      'warning_text_3'         : 'Esta ação não pode ser revertida.',
      'warning_text_1_singular': 'mensagem?',
      'warning_text_1_plural'  : 'mensagens?',
    },

    'move' : {
      'warning_title_plural'   : 'Mover %s1 mensagens',
      'warning_title_singular' : 'Mover %s1 mensagem',
      'warning_text_1'         : 'As mensagens selecionadas serão movidas para a pasta Lixo.',
      'move_message'           : 'Mover Mensagem',
      'move_messages'          : 'Mover Mensagens',
      'new_folder_submit'      : 'Confirmar',
      'new_folder_name'        : 'Criar nova pasta',
      'drag_move_message'      : 'A mover 1 mensagem',
      'drag_move_messages'     : 'A mover %s1 mensagens',
      'drag_move_contact'      : 'A mover 1 contacto',
      'drag_move_contacts'     : 'A mover %s1 contactos',
    },

    'sender_label' : {
      'to'         : 'Para:',
      'empty_from' : '[Sem Destinatário]',
    },

    'details' : {
      'date'    : 'Data',
      'cc'      : 'Cc',
      'bcc'     : 'Bcc',
      'from'    : 'De',
      'to'      : 'Para',
      'subject'  : 'Assunto',
    },

    'open' : {
      'loading'            : 'A carregar mensagem...',
      'invalid'            : 'Mensagen inválida',
      'source_code'        : 'Código fonte',
      'reply'              : 'Responder',
      'reply_all'          : 'Responder a todos',
      'forward'            : 'Encaminhar',
      'forward_attachment' : 'Encaminhar como anexo',
      'forward_new'        : 'Encaminhar como mensagem',
      'priority'           : 'Esta mensagem tem prioridade alta.',
      'flagged'            : 'Mensagem sinalizada.',

      'mdn' : {
        'requested'    : 'O remetente desta mensagem pede que envie um recibo de leitura.',
        'send'         : 'Enviar recibo de leitura',
        'sent_success' : 'O recibo de leitura foi enviado para %s1 com sucesso.',
        'sent'         : 'O recibo de leitura foi enviado para',
      },

      'recipients' : {
        'details' : 'Ver detalhes',
      },

      'attachments' : {
        'one'                 : 'Anexo',
        'multiple'            : 'Anexos',
        'preview'             : 'Pré-visualizar',
        'download'            : 'Descarregar',
        'download_all'        : 'Descarregar todos',
        'upload_cloud'        : 'Enviar ficheiro para MEO Cloud'
      },

      'image_display'         : {
        'info'                : 'Foram bloqueadas imagens para proteger a sua privacidade.',
        'image_show' : 'Mostrar Imagens?',
        'image_always_show'  : 'Mostrar sempre',
      },
    },

    'flags' : {
      'forwarded'     : 'Encaminhada',
      'answered'      : 'Respondida',
      'priority_high' : 'Prioridade alta',
      'priority_low'  : 'Prioridade baixa',
      'attachments'   : 'Com anexos',
    },

    'filter' : {
      'filter_by'     : 'Filtrar por:',
      'with_attach'   : 'Com anexos',
      'flagged'       : 'Sinalizadas',
      'unread'        : 'Não lidas',
      'order_by'      : 'Ordenar por:',
      'date'          : 'Data',
      'new'           : 'Recentes',
      'old'           : 'Antigas',
      'subject'       : 'Assunto',
      'sender'        : 'Remetente',
    },

    'list' : {
      'fetch_next'    : 'Mostrar mais',
      'fetching_next' : 'A carregar mensagens...',
      'empty'         : 'Sem mensagens',
      'loading'       : 'A carregar mensagens...',
      'invalid'       : 'Pasta inválida',
      'error'         : 'Não foi possível carregar esta pasta',

      'warnings' : {
        'spam'  : 'As mensagens colocadas na pasta Spam são eliminadas automaticamente após 30 dias.',
        'trash' : 'As mensagens colocadas na pasta Lixo são eliminadas automaticamente após 7 dias.',
      },

      'selection' : {
        'of'       : 'de',
        'message'  : 'mensagem selecionada de',
        'messages' : 'mensagens selecionadas de',
        'folder'   : 'na pasta',
        'all'      : 'Selecionar todas'
      },


      'search': {
        'subject'               : 'Assunto',
        'all'                   : 'Todos',
        'participants'          : 'Participantes',
        'where'                 : 'Onde',
        'from'                  : 'De',
        'to'                    : 'Para',
        'all_fem'               : 'Todas',
        'include_words'         : 'Contém as palavras',
        'exclude_words'         : 'Não contém as palavras',
        'between_dates'         : 'Entre as datas',
        'and'                   : 'e',
        'size'                  : 'Tamanho',
        'size_to'               : 'a',
        'unread'                : 'Não lida',
        'read'                  : 'Lida',
        'with_attach'           : 'Com anexos',
        'without_attach'        : 'Sem anexos',
        'flagged'               : 'Sinalizada',
        'unflagged'             : 'Não sinalizada',
        'clear'                 : 'Limpar',
        'any_size'              : 'Qualquer tamanho',
        'bigger'                : 'superior',
        'smaller'               : 'inferior',
        'message'               : 'Mensagem',
        'kb'                    : 'kb',
        'pick_folder'           : 'Escolher pastas',
        'advanced'              : 'Pesquisa Avançada',
        'search'                : 'Pesquisar',
        'search_for'            : 'Pesquisar por:',
        'folders_select'        : 'Selecionar pastas',
        'folders_all'           : 'Todas',
        'confirm'               : 'Confirmar',

        'results' : {
          'title'       : 'Resultados da pesquisa',
          'quicksearch' : 'resultados para',
          'fullsearch'  : 'resultados',
          'filter'      : 'resultados',
        },

        'reset' : {
          'quicksearch': 'Limpar pesquisa',
          'fullsearch' : 'Limpar pesquisa avançada',
          'filter'     : 'Limpar filtros',
        },
      }
    }
  },

  'composer' : {
    'title'                    : 'Nova mensagem',
    'draft_saved'              : 'Rascunho guardado',
    'sending_message'          : 'A enviar mensagem...',
    'subject_warning'          : 'Tem a certeza que deseja enviar a mensagem sem assunto?',
    'fetch_message_error'      : 'Não foi possível obter a mensagem do servidor',
    'transfer_share'           : 'Partilha SAPO Transfer:',
    'transfer_uploading'       : 'A enviar ficheiros',
    'transfer_available_until' : 'Ficheiro disponível até ',

    'details' : {
      'from'              : 'De:',
      'to'                : 'Para:',
      'cc'                : 'Cc:',
      'bcc'               : 'Bcc:',
      'subject'           : 'Assunto:',
      'add_contacts'      : 'Adicionar contactos',
      'show_cc_bcc'       : 'Ver campos Cc e Bcc',
      'frequent_contacts' : 'Adicionar contactos frequentes',
      'priority'          : 'Prioridade',
      'priority_high'     : 'Alta',
      'priority_normal'   : 'Normal',
      'priority_low'      : 'Baixa',
      'receipt'           : 'Recibo de Leitura',
      'attachments'       : 'Anexos',
      'add_attachments'   : 'Adicionar e gerir anexos',
    },
    'footer' : {
      'send'              : 'Enviar',
      'discard'           : 'Descartar',
      'saving'            : 'A gravar...',

    },
    'modals' : {
      'attachments'          : 'Anexos',
      'choose_attachment'    : 'Escolha um anexo',
      'drag_here'            : 'ou arraste para aqui',
      'preview'              : 'Pré-visualizar',
      'attach_sapotransfer'  : 'Anexar por SAPO Transfer',
      'attach_meocloud'      : 'Anexar por MEO Cloud',
      'finish'               : 'Concluir',


      'embed_email'          : 'Inserir no email',
      'transfer_files_name'  : '%s1 ficheiros via SAPO Transfer',
      'transfer_file_via'    : 'via SAPO Transfer',
    },

    'meocloud' : {
      '1d'                   : '1 Dia',
      '30d'                  : '1 Mês',
      '90d'                  : '3 Meses',
      'expire_link'          : 'Validade do link:',
      'forever'              : 'Para sempre',
      'home'                 : 'Início',
      'remove_consent'       : 'Remover autorização',
      'search'               : 'Pesquisar',
      'search_current'       : 'Esta pasta',
      'search_all'           : 'Todas',
      'create_folder'        : 'Criar Pasta',
      'attachments_meo'      : 'Anexos MEO Cloud',
      'upload'               : 'Enviar ficheiros',
      'grid_view'            : 'Vista em grelha',
      'list_view'            : 'Vista em lista',
      'empty_folder'         : 'Não existem ficheiros',
      'upload_here'          : 'Guardar anexo nesta pasta',
      'save_to_cloud'        : 'Guardar no MEO Cloud',
      'files_name'           : '%s1 ficheiros via MEOCloud',
      'file_via'             : 'via MEOCloud',

      'authorize' : {
        'text_1'          : "Agora já pode partilhar ficheiros guardados na sua MEO Cloud através do SAPO Mail, de forma rápida, simples e segura!",
        'text_2'          : "Necessita apenas de autorizar uma única vez o seu endereço de email na sua conta MEO Cloud.",
        'text_3'          : "Se não tem conta MEO Cloud, ",
        'text_3_link'     : 'crie aqui',
        'text_3_pos_link' : ' a sua conta gratuita.',
        'text_4'          : "Pode remover a autorização quando desejar",
        'button'          : "Autorizar conta de email",
      }
    }
  },

  'folders' : {
    'title'           : 'Pastas',
    'loading'         : 'A carregar pastas',
    'empty_folders'   : 'Lista de pastas vazia',
    'select_folders'  : 'Selecionar pastas',
    'select_folder'   : 'Selecionar pasta',
    'folders_name'    : 'Nome da pasta',
    'new_name'        : 'Novo nome',
    'top_folder_name' : 'Pastas (nível de topo)',
    'all_folders_name': 'Todas as pastas',

    'labels' : {
      'inbox'  : 'Caixa de Entrada',
      'sent'   : 'Enviados',
      'spam'   : 'Spam',
      'drafts' : 'Rascunhos',
      'trash'  : 'Lixo',
    },

    'search' : {
      'placeholder' : 'Pesquisar',
      'root_folder' : 'Pastas',
    },

    'empty' : {
      'cancel'            : 'Cancelar',
      'confirm'           : 'Confirmar',
      'title'             : 'Esvaziar pasta %s1',
      'confirmation'      : 'Pretende esvaziar a pasta %s1?',
      'messages_to_trash' : 'Todas as mensagens serão enviadas para a pasta Lixo.',
      'delete_permanent'  : 'Todas as mensagens desta pasta serão apagadas permanentemente.',
      'non_reversable'    : 'Esta ação não pode ser revertida',
    },

    'edit' : {
      'rename' : 'Renomear',
      'title'  : 'Editar nome da pasta %s1',
      'new_name'  : 'Novo nome',
    },

    'delete' : {
      'title'                  : 'Apagar pasta',
      'confirmation_one'       : 'Tem a certeza que deseja apagar a pasta %s1 e todo o seu conteudo?',
      'confirmation_sub'       : 'Tem a certeza que deseja apagar a pasta %s1, subpastas e todo o seu conteudo?',
      'confirmation_reversible': 'Todas as mensagens serão eliminadas e não poderão ser recuperadas.',
    },

    'move' : {
      'submit'     : 'Mover',
      'title'      : 'Mover pasta %s1',
      'drag_move_folder'  : 'A mover 1 pasta',
      'drag_move_folders' : 'A mover %s1 pastas',
    },

    'actions' : {
      'search_folders' : 'Pesquisar',
      'add_folder'     : 'Criar pasta',
      'add_subfolder'  : 'Criar sub-pasta',
      'add_folder_in'  : 'Criar sub-pasta na pasta %s1',
      'refresh'        : 'Atualizar pastas',
      'edit'           : 'Renomear',
      'move'           : 'Mover',
      'delete'         : 'Apagar',
      'empty'          : 'Esvaziar pasta',
      'add_filter'     : 'Criar filtro',
      'expand_all'     : 'Expandir todas',
      'collapse_all'   : 'Colapsar todas',
    },
  },

  'contacts' : {
    'title'              : 'Contactos',
    'person_title'       : 'Contacto',
    'group_title'        : 'Grupo',
    'add_to_group_title' : 'Adicionar a grupo',
    'loading'            : 'A carregar contactos',
    'selected_contacts'  : 'Contactos selecionados',
    'selected'           : 'Selecionados',

    'groups'  : 'Grupos',
    'persons' : 'Contactos',
    'frequent': 'Contactos frequentes',


    'modals' : {
      'to_group_title'    : 'Adicionar contactos ao grupo: %s1',
    },

    'import' : {
      'title'               : 'Importar contactos',
      'action_select_file'  : 'Importar ficheiro',
      'description'         : 'Para importar contactos escolha um ficheiro CSV, Vcard, outros',

      'select_result' : {
        'title'         : 'Contactos importados até agora',
        'sub_title'     : 'Verificação de dados importados',
        'description'   : 'Antes da importação verifique os %s1 apresentados.',
        'check_message' : 'A correspondência dos campos está correcta?'
      },

      'field_label': {
        'name'        : 'Nome',
        'email'       : 'E-mail',
        'phone'       : 'Telemóvel',
        'company'     : 'Empresa',
        'birthday'    : 'Aniversário',
        'address'     : 'Morada'
      },

      'button_actions'       : {
        'import' : 'Sim, continuar importação',
        'cancel' : 'Não, cancelar',
      },

      'messages': {
        'event_import_progress' : 'A carregar...',
        'success_person_list_add'       : 'Lista de contactos importado com sucesso',
        'error_max_contacts_list_add'   : 'Não pode importar uma lista com mais de %s1 contactos',
        'error_exceeded_number_contact' : 'Não pode importar mais contactos, excedeu o limite de importação',
        'contacts_person_list_add'         : 'Ocorreu um erro a importar a lista de contactos',
        'error_max_size_file'           : 'Tamanho do ficheiro não permitido, deverá ter no máximo %s1 kb.',
        'error_type_file'               : 'Ocorreu um erro a ler o ficheiro, o tipo não é permitido.',
      },
    },

    'duplicate_finder' : {
      'title' : 'Encontrar duplicados',
      'sub_title' : 'Corrigir contactos duplicados',
      'duplicated_contacts' : 'contactos duplicados',
      'duplicated_text1' : 'Foram detetados contactos com dados semelhantes ou iguais.',
      'duplicated_text2' : 'Verifique e agregue a informação num único contacto.',
      'similar_contacts' : 'Para os contactos com dados semelhantes pode:',
      'save_unique_contact' : 'Guardar como contactos independentes',
      'add_unique_contact' : 'Agregar os dados e transformar num único contacto',
      'alert1' : 'Atenção:',
      'alert2' : 'Os contactos que não forem selecionados serão apagados da sua lista de contactos.',
      'button_add' : 'Agregar contactos',
      'button_independent' : 'Manter como contactos separados',
      'title_last_step': "Dados agregados",
      'name_required': 'Nome (obrigatório)',
      'error_multiple_names': 'Remova os campos duplicados',
      'add_group_contacts' : 'Guardar contactos?',
      'modal_group_duplicate_confirm': 'Deseja realizar a ação?',
      'button_group' : 'Juntar contactos',
      'title_modal_submit': 'Agregar Contactos',
      'text_modal_submit_1': 'Tem a certeza que deseja agregar %s1 contacto(s) num só?',
      'text_modal_submit_2': 'Todos os restantes contactos serão eliminados.',
    },

    'list' : {
      'error'          : 'Não foi possivel carregar a lista de contactos.',
      'loading'        : 'A carregar contactos',
      'empty_results'  : 'Sem contactos',
      'filter_by'      : 'Filtrar por:',
      'results_filter' : 'A filtrar por',
      'filter_all'     : 'Todos',
      'filter_persons' : 'Contactos',
      'filter_groups'  : 'Grupos',
      'filter_reset'   : 'Limpar filtros',
      'results_query'  : 'Resultados'
    },

    'actions' : {
      'close'                : 'Fechar',
      'refresh'              : 'Atualizar contactos',
      'search'               : 'Pesquisar contactos',
      'filter'               : 'Filtrar contactos',
      'add_group'            : 'Criar grupo',
      'add_person'           : 'Criar contacto',
      'edit'                 : 'Editar contacto',
      'edit_person'          : 'Editar contacto',
      'edit_group'           : 'Editar grupo',
      'add_filter'           : 'Criar filtro',
      'import'               : 'Importar contactos',
      'export'               : 'Exportar contactos',
      'duplicated'           : 'Encontrar duplicados',
      'delete'               : 'Apagar',
      'delete_group'         : 'Apagar grupo',
      'add_to_group'         : 'Adicionar a grupo',
      'add_persons_to_group' : 'Adicionar contactos',
      'remove_from_group'    : 'Remover do grupo',
      'send_mail'            : 'Enviar email',
      'select_all'           : 'Selecionar todos',
      'select_reset'         : 'Desmarcar todos'
    },

    'form' : {
      'required_field' : 'Campo de preenchimento obrigatório',
      'group_add'      : 'Adicionar grupo',
      'group_edit'     : 'Editar grupo',
      'person_add'     : 'Adicionar contacto',
      'person_edit'    : 'Editar cotnacto',
      'required'       : 'Obrigatório',
      'name'           : 'Nome',
      'email'          : 'E-mail',
      'mobile_phone'   : 'Telemóvel',
      'home_address'   : 'Morada',
      'company'        : 'Empresa',
      'birth_date'     : 'Data de nascimento',
      'notes'          : 'Notas',
      'error_required' : 'Este campo é de preenchimento obrigatório.',
      'error_mobile'   : 'Numero de telemóvel inválido.',
      'error_email'    : 'E-mail inválido.',
      'saving'         : 'A gravar',
      'birthday'    : 'Aniversário',
    },

    'delete' : {
      'contacts_multi_title'      : 'Apagar contactos',
      'contacts_single_title'     : 'Apagar contacto',
      'groups_multi_title'        : 'Apagar grupos',
      'groups_single_title'       : 'Apagar grupo',
      'contacts_single_confirm_pre' : 'Tem a certeza que deseja a apagar o contacto',
      'contacts_multi_confirm_pre'  : 'Tem a certeza que deseja apagar ',
      'contacts_single_confirm_pos' : '?',
      'contacts_multi_confirm_pos'  : ' contactos?',

      'groups_single_confirm_pre' : 'Tem a certeza que deseja a apagar o grupo',
      'groups_multi_confirm_pre'  : 'Tem a certeza que deseja apagar ',
      'groups_single_confirm_pos' : '?',
      'groups_multi_confirm_pos'  : ' grupos?',

      'confirm_one_pre'         : 'Tem a certeza que deseja a apagar o contacto ',
      'confirm_pos'         : '?',
      'confirm_multi_pre'       : 'Tem a certeza que deseja apagar',
      'confirm_multi_pos'       : ' contactos',
      'confirm_group_multi_pos' : ' grupos',
      'non_reversable'          : 'Não é possivel reverter esta ação.',
    },

    'person' : {
      'invalid' : 'Contacto não encontrado',
      'groups'  : 'Presente nos grupos:',
    },

    'group' : {
      'invalid' : 'Grupo não encontrado',
      'members' : 'Contactos no grupo',
      'empty'   : 'Não existem contactos no grupo'
    },

    'export' : {
      'title'           : 'Exportar lista de contactos',
      'pick_exporter'   : 'Escolha um dos formatos',
      'export_csv'      : 'Valores separados por vírgulas (Microsoft Outlook)',
      'export_vcard'    : 'vCard (3.0)',
      'export_file'     : 'Exportar',
      'export_csv_name' : 'contactos.csv',
    },

    'select_modal' : {
      'title' : 'Contactos frequentes',

      'actions' : {
        'cancel'  : 'Cancelar',
        'choose'  : 'Escolher'
      },

      'label': {
        'selected_contacts' : 'contactos selecionados',
        'no_contacts'       : 'Sem contactos',
        'selected'          : 'Selecionados',

        'no_results': {
          'persons'  : 'Nenhum contacto encontrado',
          'groups'   : 'Nenhum grupo encontrado',
          'frequent' : 'Nenhum favorito encontrado',
        }
      }
    }
  },

  'premium' : {
    'forwarding_disabled' : 'O encaminhamento de mensagens só está disponível para utilizadores SAPO Mail Premium.',
    'imap_disabled'       : 'O acesso IMAP/POP via programas externos só está disponível para utilizadores SAPO Mail Premium.',
    'subscribe_label'     : 'Aderir ao Premium',

    'remove_ads_modal' : {
      'title' : 'Exclusivo SAPO Mail Premium',
      'text'  : 'Adira ao Premium para uma experiência ainda mais simples, com remoção de todos os formatos de publicidade, 65GB de armazenamento, acesso via programas de email e ainda mais vantagens.',
    }
  },

  'settings' : {
    'title'        : 'Definições',

    'menu' : {
      'my_account'          : 'A minha conta',
      'sso_profile'         : 'O meu perfil',
      'password_reset'      : 'Alterar password',
      'manage_recover'      : 'Dados de recuperação',
      'email'               : 'E-mail',
      'identities'          : 'Identidades e assinaturas',
      'messages'            : 'Opções de mensagens',
      'out_of_office'       : 'Mensagem de ausência',
      'kids'                : 'SAPO Mail Kids',
      'security'            : 'Segurança',
      'imap_block'          : 'Acesso IMAP/POP',
      'newsletters'         : 'Newsletters SAPO',
      'newsletters_manage'  : 'Gerir newsletters',
      'more_options'        : 'Mais opções',
      'filters'             : 'Filtros',
      'antispam'            : 'Anti-Spam',
      'housekeeper'         : 'Limpeza de E-mail',
      'notifications'       : 'Notificações',
      'layout'              : 'Cores, tamanho e painel',
      'configuration'       : 'Assistente de configuração',
      'wizard'              : 'Configurações rápidas',
      'whats_new'           : 'Novas funcionalidades',
      'forwarding'          : 'Encaminhamento de mensagens',
      'smokescreen_addresses': 'Endereços incógnitos',
      'allowed_emails'       : 'Endereços permitidos',
      'blocked_emails'       : 'Endereços bloqueados',
    },

    'identities' : {
      'select_contacts' : 'Selecionar contactos',
      'set_default'     : 'Definir como identidade principal',
      'default'         :' Principal',
      'delete_warning'  : 'Tem a certeza que quer apagar esta identidade?',
      'not_reversible'  : 'Não é possível reverter esta ação.',

      'actions' : {
        'add'    : 'Adicionar nova identidade',
        'edit'   : 'Editar identidade',
        'delete' : 'Apagar identidade'
      },

      'titles' : {
        'add'           : 'Criar identidade',
        'edit'          : 'Editar identidade',
        'list'          : 'Identidades e assinaturas',
        'delete_warning': 'Aviso'
      },

      'labels' :  {
        'id'         : 'Nome da identidade',
        'name'       : 'O seu nome',
        'email'      : 'E-mail',
        'bcc'        : 'Enviar todas as mensagens em BCC para',
        'signature'  : 'Assinatura HTML',
        'default'    : 'Definida como identidade principal',
        'invalid_id' : 'Nome inválido',
      },
    },

    'messages' : {
      'labels' : {
        'images'           : 'Imagens',
        'sent_messages'    : 'Mensagens Enviadas',
        'date_conjunction' : 'e',
        'message_to_send'  : 'Mensagem a enviar',
        'forwards'         : 'Reencaminhamento de mensagens',
      },

      'title'                     : 'Opções de Mensagens',
      'images_option_text'        : 'Não mostrar imagens em mensagens HTML exceto quando solicitadas',
      'sent_messages_option_text' : 'Solicitar recibos de leitura',
    },

    'forwarding' : {
      'title'  : 'Encaminhamento de mensagens',

      'content' : {
        'info'  : 'Envie para outro endereço de email todas as mensagens que receber, de forma automática, sem precisar de aceder a esta conta.',
      },

      'notices' : {
        'local_copy'  : 'As mensagens só ficarão disponíveis no endereço indicado abaixo.',
      },

      'labels' : {
        'fowarding_settings'     : 'Definições de encaminhamento',
        'forwarding_address'     : 'Endereço de encaminhamento',
        'forwarding_addresses'   : 'Endereços de encaminhamento',
        'forwarding_settings'    : 'Definições de encaminhamento',
        'enable_forwarding'      : 'Ativar encaminhamento de mensagens',
        'keep_copy'              : 'Manter uma cópia das mensagens encaminhadas na minha conta SAPO Mail',
        'add_address'            : 'Todas as mensagens serão encaminhadas para o endereço de email:',
        'add_address_additional' : 'Endereço de encaminhamento adicional',
      },
    },

    'out_of_office' : {
      'labels' : {
        'define_message'   : 'Definir mensagem',
        'period'           : 'Período',
        'between_dates'    : 'Entre as datas',
        'date_conjunction' : 'e',
        'message_to_send'  : 'Mensagem a enviar'
      },

      'placeholders' : {
        'message_text_area' : 'Escrever'
      },

      'title'                         : 'Opções de Mensagens',
      'define_message_text'           : 'A mensagem de ausência é enviada em resposta a cada email recebido, com o limite de 1 por semana por cada contacto',
      'activated'                     : 'Ativada',
      'deactivated'                   : 'Desativada',

      'invalid' : {
        'message' : "Tem de escrever uma mensagem."
      },

      'predefined_messages' : {
        'no_dates'   : 'Estou ausente',
        'date_one'   : 'Estou ausente a partir de %s2',
        'date_two'   : 'Estou ausente até %s1',
        'both_dates' : 'Estou ausente de %s1 até %s2'
      },

      'actions' : {
        'replace_predefined_message' : 'Repor mensagem predefinida',
      },
    },

    'imap' : {
      'title'                : 'Acesso IMAP/POP',
      'imap_description'     : 'Para segurança adicional, pode impedir o acesso à sua conta através de programas de email (por exemplo, Outlook). Recomendamos a utilização desta opção se usa autenticação em dois passos.',
      'imap_disable'         : 'Bloquear IMAP/POP',
      'imap_notice'          : 'Nota: Ao desativar esta opção só poderá aceder aos seus emails em https://mail.sapo.pt. Caso tenha a sua conta configurada num programa no seu PC, telemóvel ou tablet, esse programa deixará de receber e enviar mensagens desta conta.',
      'imap_disabled_notice' : 'IMAP/POP bloqueados: Os seus emails só estão acessíveis em https://mail.sapo.pt. Caso tenha a sua conta configurada num programa no seu PC, telemóvel ou tablet, esse programa não poderá receber nem enviar mensagens desta conta.',
      'imap_not_allowed'     : 'A sua conta não permite a ativação destes protocolos. Para mais informações consulte as Condições de Utilização da sua conta.',

      'labels' : {
        'configuration' : 'Configuração do IMAP/POP',
      },

      'warning_modal' : {
        'title'          : 'Confirmação',
        'allow_line1'    : 'Permitir acesso a esta conta via IMAP/POP?',
        'allow_line2'    : 'Não recomendado se usa autenticação em dois passos. O IMAP e POP não usam autenticação em dois passos e apenas requerem a password.',
        'block_line1'    :  'Bloquear acesso a esta conta via IMAP/POP?',
        'block_line2'    :  'Esta opção aumenta a segurança mas, caso tenha a sua conta configurada num programa (por exemplo, Outlook), esse programa deixará de receber e enviar mensagens desta conta.',
        'cancel_button'  : 'Cancelar' ,
        'confirm_button' : 'Confirmar' ,
      }
    },

    'newsletters' : {
      'title'                     : 'Newsletters',
      'info1'                     : 'Faça aqui a subscrição e gestão das suas newsletters SAPO',
      'info2'                     : 'Relembramos que ao subscrever as newsletters SAPO está a concordar com a',
      'loading'                   : 'A carregar',
      'loading_error'             : 'Não foi possivel carregar',
      'private_policy'            : 'Política de Privacidade',
      'exemple'                   : 'Exemplo',
      'subscribe'                 : 'Subscrever',
      'remove_subscription'       : 'Remover Subscrição',
      'day'                       : 'Dia',
      'month'                     : 'Mês',
      'year'                      : 'Ano',
      'chose_an_option'           : 'Escolha uma opção',

      'fields' : {
        'label_age' : 'Data de Nascimento',
        'invalid_date' : 'Data inválida.'
      },
    },

    'filters' : {
      'no_filters'                : 'Não tem filtros criados',
      'delete_warning_text'       : 'Tem a certeza que quer apagar este filtro?',
      'delete_warning_reversible' : 'Não é possível reverter esta ação.',

      'invalid_name'  : 'É necessário um nome para o filtro.',
      'invalid_email' : 'Tem de adicionar um endereço de email.',
      'invalid_body'  : 'Por favor, escreva o texto a pesquisar.',
      'invalid_flags' : 'Tem de selecionar pelo menos uma ação.',
      'invalid_folder': 'Tem de selecionar uma pasta.',
      'invalid_From'                                                 : 'Tem de adicionar um endereço de email.',
      'invalid_To'                                                   : 'Tem de adicionar um endereço de email.',
      'invalid_Cc'                                                   : 'Tem de adicionar um endereço de email.',
      'invalid_Subject'                                              : 'Tem de adicionar um texto a pesquisar.',
      'invalid_Body'                                                 : 'Tem de adicionar um texto a pesquisar.',
      'invalid_To,Cc,Bcc,Resent-to,From,Sender,Reply-to,Resent-from' : 'Tem de adicionar um endereço de email.',

      'content' : {
        'inbox_filters' : 'As mensagens que correspondam às regras definidas por estes filtros serão automaticamente organizadas de acordo com as ações que escolher.',
      },

      'upgrade_message' : 'Para aumentar o limite de filtros permitidos subscreva um plano.',

      'notices' : {
        'usage_1' : 'Está a utilizar',
        'usage_2' : 'de',
        'usage_3' : 'filtros disponíveis no seu plano.',
        'upgrade_message' : 'Para aumentar o limite de filtros permitidos subscreva um plano.',
      },

      'actions' : {
        'add'             : 'Criar filtro',
        'edit'            : 'Editar filtro',
        'delete'          : 'Apagar filtro',
        'add_condition'   : 'Adicionar condição',
        'select_folder'   : 'Escolher pasta',
        'delete_condition': 'Apagar condição',
        'search'          : 'Pesquisar filtros',
      },

      'titles' : {
        'list' : 'Filtros',
      },

      'labels' : {
        'title'             : 'Filtro',
        'filter_name'       : 'Nome do filtro',
        'rules'             : 'Regras',
        'apply_filter'      : 'Aplicar este filtro quando se verificarem',
        'actions'           : 'Ações',
        'pick_all'          : 'Todas as condições abaixo',
        'pick_one'          : 'Qualquer das condições abaixo',
        'conditions'        : 'Condições',
        'is'                : 'Igual a',
        'not is'            : 'Não é',
        'contains'          : 'Contém',
        'not contain'       : 'Não Contém',
        'pick_2'            : 'ou',
        'pick_1'            : 'e',
        'perform_action'    : 'Realizar a ação',
        'user_move'         : 'Receber na pasta',
        'user_discard'      : 'Apagar mensagem',
        'flag_only'         : 'Apenas marcar a mensagem',
        'mark_message_as'   : 'E marcar a mensagem como',
        'seen'              : 'Lida',
        'flagged'           : 'Sinalizada',
        'answered'          : 'Respondida',
        'filter_flags'      : 'Mensagens marcadas como:',
        'status'            : 'Estado',
        'Ingo_Rule_User_FlagOnly' : 'Apenas marcar mensagens',
        'Ingo_Rule_User_Move'    : 'Receber na pasta',
        'Ingo_Rule_User_Discard' : 'Apagar mensagens',

        'From'                                                 : 'De',
        'To'                                                   : 'Para',
        'Cc'                                                   : 'Cc',
        'Subject'                                              : 'Assunto',
        'Body'                                                 : 'Corpo',
        'To,Cc,Bcc,Resent-to,From,Sender,Reply-to,Resent-from' : 'Participante (De, Para, etc.)',

        'mark_message_Ingo_Rule_User_Move'       : 'E marcar a mensagem como:',
        'mark_message_Ingo_Rule_User_FlagOnly'   : 'Marcar como:',
      },
    },

    'layout': {
      'title': 'Cores, tamanhos e painel',
      'schemes'      : 'Temas coloridos',

      'schemes_colors' : {
        'green'         : 'Verde',
        'blue'          : 'Azul',
        'orange'        : 'Laranja',
        'violet'        : 'Roxo',
        'red'           : 'Vermelho',
        'emerald'       : 'Esmeralda',
        'pink'          : 'Rosa',
        'grey'          : 'Cinzento',
      },

      'view_mode'    : 'Modo de visualização',
      'light_mode'   : 'Modo claro',
      'dark_mode'    : 'Modo escuro',
      'default_mode' : 'Usar Opções do sistema operativo',
      'reading_pane' : 'Painel de leitura de e-mails',
      'side_view'    : 'Mostrar de lado',
      'bottom_view'  : 'Mostrar em baixo',
      'overlay_view' : 'Mostrar sobreposto',
      'font_size'    : 'Tamanho da Letra',
      'font_small'   : 'Pequena',
      'font_default' : 'Normal',
      'font_large'   : 'Grande',
    },

    'whitelist' : {
      'title': {
        'add_new': 'Adicionar endereço permitido',
        'main': 'Endereços permitidos',
      },
      'content': {
        'inbox_whitelist' : 'Todas as mensagens recebidas dos endereços ou domínios contidos nesta lista irão sempre ser entregues na Caixa de entrada, independentemente do seu conteúdo.',
        'whitelist_empty': 'Não existem endereços nesta lista.',
        'senders' : 'Endereços permitidos',
        'rule' : 'Tipo',
        'address' : 'Endereço',
        'domain' : 'Domínio',
      },
      'actions' : {
        'remove_address': 'Remover endereço',
        'remove_domain': 'Remover domínio',
        'add': 'Adicionar email/domínio',
        'search': 'Pesquisar na lista',
      },

      'legends' : {
        'add_sender_address' : 'Adicione um endereço ou domínio à lista a permitir',
      },

      'labels' : {
        'add_sender_address': 'Endereço de email/Domínio',
      },

      'notices' : {
        'usage_1' : 'Está a utilizar',
        'usage_2' : 'de',
        'usage_3' : 'endereços permitidos disponíveis no seu plano.',
        'upgrade_message' : 'Para aumentar o limite de endereços permitidos subscreva um plano.',
      },

      'errors' : {
        'duplicate_sender' : 'O endereço de email já existe na sua lista de permitidos.',
        'email'            : 'O endereço de email não é válido.',
        'domain'           : 'O domínio não é válido.',
      },

      'antispam_modal' : {
        'title'         : 'Adicionar endereço à lista de permitidos',
        'description_1'   : 'Todas as mensagens recebidas dos endereços ou domínios selecionados serão sempre entregues na sua Caixa de Entrada, independentemente do seu conteúdo. ',
        'limit_exceeded'  : 'Atingiu o limite máximo de endereços permitidos no seu plano.',
        'options'         : {
          'domain' : 'Domínio',
          'address'  : 'Endereço de email',
        }
      },
    },

    'blacklist' : {
      'title': {
        'add_new': 'Adicionar endereço bloqueado',
        'main': 'Endereços bloqueados',
      },
      'content': {
        'inbox_blacklist' : 'Todas as mensagens recebidas dos endereços ou domínios contidos nesta lista irão sempre ser entregues na pasta Spam, independentemente do seu conteúdo.',
        'blacklist_empty': 'Não existem endereços nesta lista.',
        'senders' : 'Endereços bloqueados',
        'rule' : 'Tipo',
        'address' : 'Endereço',
        'domain' : 'Domínio',
      },
      'actions' : {
        'remove_address': 'Remover endereço',
        'remove_domain': 'Remover domínio',
        'add': 'Adicionar email/domínio',
        'search': 'Pesquisar na lista',
      },

      'legends' : {
        'add_sender_address' : 'Adicione um endereço ou domínio à lista a bloquear',
      },

      'labels' : {
        'add_sender_address': 'Endereço de email/Domínio',
      },

      'notices' : {
        'usage_1' : 'Está a utilizar',
        'usage_2' : 'de',
        'usage_3' : 'endereços bloqueados disponíveis no seu plano.',
        'upgrade_message' : 'Para aumentar o limite de endereços bloqueados subscreva um plano.',
      },

      'errors' : {
        'duplicate_sender' : 'O endereço de email já existe na sua lista de bloqueados.',
        'email'            : 'O endereço de email não é válido.',
        'domain'           : 'O domínio não é válido.',
      },

      'antispam_modal' : {
        'title'         : 'Adicionar à lista de bloqueados',
        'description_1'   : 'Todas as mensagens recebidas dos endereços ou domínios selecionados serão sempre entregues na pasta Spam, independentemente do seu conteúdo. ',
        'limit_exceeded'  : 'Atingiu o limite máximo de endereços bloqueados no seu plano.',
        'options'         : {
          'domain' : 'Domínio',
          'address'  : 'Endereço',
        }
      },
    },

    'smokescreen_addresses' : {
      'title': {
        'add_new': 'Adicionar endereço incógnito',
        'main': 'Endereços incógnitos',
      },
      'content': {
        'sub_01'    : 'Crie endereços descartáveis para subscrever newsletters ou registar-se em serviços sem ter de fornecer o seu endereço real. Se um deles começar a receber spam, pode facilmente identificar a fonte e bloqueá-la.',
        'sub_02'    : 'Escolha uma palavra como prefixo e o resto do endereço é gerado de forma aleatória.',
        'list_empty': 'Não existem endereços nesta lista.',
        'addresses' : 'Endereços incógnitos',
        'status'    : 'Estado',
        'clipboard_copied'    : 'Copiado',
      },
      'actions' : {
        'add'   : 'Adicionar endereço',
        'search': 'Pesquisar endereços',
      },

      'premium' : {
        'disabled' : 'Pode criar %s1 endereço incógnito. Para criar até 500 endereços, adira ao SAPO Mail Premium.',
      },

      'legends' : {
        'add_address' : 'Adicione um endereço incógnito',
      },

      'labels' : {
        'prefix': 'Prefixo (por exemplo, lojaonline)',
      },

      'notices' : {
        'usage_1'    : 'Está a utilizar',
        'usage_2'    : 'de',
        'usage_3'    : 'endereços incógnitos disponíveis no seu plano.',
        'create_new' : 'O endereço será gerado automaticamente, com o prefixo que escolher mais uma parte aleatória e o domínio @i.sapo.pt (por exemplo, lojaonline.abcdef.1234@i.sapo.pt).',
      },

      'errors' : {
        'prefix' : 'O prefixo apenas pode conter letras e números e ter entre 3 a 30 caracteres.',
      },
    },


    'housekeeper' : {
      'title'             : 'Limpeza de E-mail',
      'title_search'      : 'Limpeza de Email - Selecionar mensagens',
      'title_results'     : 'Limpeza de Email - Resumo de limpeza',
      'selected_messages' : 'Mensagens selecionadas',
      'find_messages'     : 'Encontrar Mensagens',
      'old'               : 'Antigas',
      'more_than'         : 'Com mais de ',
      '30_days'           : '30 dias',
      '6_months'          : '6 meses',
      '1_year'            : '1 ano',
      'on'                : 'na',
      'inbox'             : 'Caixa de entrada',
      'change'            : 'Alterar',
      'unread'            : 'Não lidas',
      'read'              : 'Lidas',
      'heavy'             : 'Volumosas',
      'bigger_than'       : 'e maiores que ',
      'search'            : 'Encontrar',

      'delete_warning_title' : 'Apagar mensagens?',
      'delete_warning_text_1': 'Tem a certeza que deseja apagar %s1 mensagens?',
      'delete_warning_text_2': 'As mensagens serão apagadas de imediato, para libertar espaço na sua conta.',
      'delete_warning_text_3': 'Esta ação não pode ser revertida.',

      'results_header' : 'Iniciámos o processo de limpeza do seu E-mail',
      'results_text_1' : 'Este processo pode demorar vários minutos',
      'results_text_2' : 'Receberá um email quando o processo estiver concluído.',

      'results_move_1' : 'Serão movidas',
      'results_move_2' : 'mensagens da pasta',
      'results_move_3' : 'para a pasta',

      'results_delete_1' : 'Serão apagadas',
      'results_delete_2' : 'mensagens da pasta',
    },

    'browser_notifications' : {
      'title'                 : 'Notificações',
      'description'           : 'Receba notificações de novas mensagens',
      'enable'                : 'Receber notificações do sistema operativo',
      'disable'               : 'Desativar notificações do sistema operativo',
      'info_click'            : 'Após ativar as notificações, clique em aceitar na janela do browser',
      'info_devices'          : 'Para receber notificações noutros browsers ou dispositivos, repita o processo de mostar notificações em cada um.',
      'info_blocked_1'        : 'As suas permissões de notificações encontram-se bloqueadas pelo browser.',
      'info_blocked_2'        : 'Para voltar a mostrar-las aceda às definições do seu browser e encontre a opção Notificações',
      'not_supported_1'       : 'O seu dispositivo não suporta notificações do browser.',
    },

    'kids' : {
      'title': 'SAPO Mail Kids',
      'form_fields' : {
        'auth': {
          'title': 'Autenticação do Encarregado de Educação',
          'description': 'Para definir as regras da conta Kids coloque os dados da conta SAPO do encarregado de educação',
          'account' : {
            'description': 'Email/Número de Telefone do Encarregado de Educação',
            'button_actions': {
              'submit': 'Submeter'
            }
          },
          'secret' : {
            'description': {
              'USERPW': 'Password da conta do Encarregado de Educação',
              'PHONE': 'Código enviado para o telemóvel do Encarregado de Educação',
              'EMAIL': 'Código enviado para o email do Encarregado de Educação'
            },
            'button_actions': {
              'back' : 'Voltar',
              'submit': 'Submeter'
            }
          }
        },
        'definitions': {
          'authorized_emails' : {
            'title'         : 'Emails autorizados',
            'description'   : 'Autorize os endereços de email que podem contactar a criança e evite que esta receba emails indesejáveis.',
            'radio_button' : {
              'description'   : 'Quero que o meu filho:',
              'options': {
                'active'      : 'Receba e envie emails de uma lista de endereços autorizados',
                'not_active'  : 'Receba emails de qualquer endereço',
              }
            }
          },
          'not_authorized_emails' : {
            'title'         : 'Emails não autorizados',
            'radio_button' : {
              'description'   : 'Os emails não autorizados são:',
              'options': {
                'folder'      : 'Recebidos na pasta "Desconhecidos"(esta pasta poderá ser acedida pelo seu filho)',
                'reject'  : 'Apagados sem confirmação',
              }
            }
          },
        },
        'whitelist' : {
          'title': 'Lista autorizada',
          'description': 'Só são recebidos e enviados emails de e para os seguintes endereços:',
          'label_input': 'Adicionar email',
          'button_actions': {
            'submit': 'Adicionar'
          }
        }
      },

    }
  },

  'logout' : {
    'loading' : 'A terminar a sessão aguarde....'
  }
}
